import { render, staticRenderFns } from "./FormConfigForm.vue?vue&type=template&id=9657a24a&"
import script from "./FormConfigForm.vue?vue&type=script&lang=js&"
export * from "./FormConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./FormConfigForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports